import React from 'react';
import { TooltipHost } from '@fluentui/react';
import { EmptyColumn, SearchableComboBox } from '@ioip/core/lib';
export const DepartmentSelector = (props) => {
    const onSearch = (keyword, item) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const includeName = ((_d = (_c = (_b = (_a = item.name) === null || _a === void 0 ? void 0 : _a.normalize("NFD")) === null || _b === void 0 ? void 0 : _b.replace(/[\u0300-\u036f]/g, '')) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === null || _d === void 0 ? void 0 : _d.includes(keyword)) || false;
        const includeCode = ((_h = (_g = (_f = (_e = item.country) === null || _e === void 0 ? void 0 : _e.name.normalize("NFD")) === null || _f === void 0 ? void 0 : _f.replace(/[\u0300-\u036f]/g, '')) === null || _g === void 0 ? void 0 : _g.toLowerCase()) === null || _h === void 0 ? void 0 : _h.includes(keyword)) || false;
        return includeName || includeCode;
    };
    return React.createElement(SearchableComboBox, { label: props.label || '', columns: [
            {
                isResizable: true,
                key: 'Nombre',
                maxWidth: 300,
                minWidth: 180,
                name: 'Nombre',
                onRender: (item) => React.createElement(TooltipHost, { content: item.name }, item.name)
            },
            {
                isResizable: true,
                key: 'País',
                maxWidth: 300,
                minWidth: 180,
                name: 'País',
                onRender: (item) => { var _a, _b; return React.createElement(TooltipHost, { content: ((_a = item.country) === null || _a === void 0 ? void 0 : _a.name) || '' }, ((_b = item.country) === null || _b === void 0 ? void 0 : _b.name) || ''); }
            },
            EmptyColumn
        ], defaultItem: { name: '[Seleccione...]' }, errorMessage: props.errorMessage, keyBinding: x => x.id, onChanged: (item) => props.onChanged(item), onFilter: props.onFilter, onRenderSelectedText: value => (value === null || value === void 0 ? void 0 : value.id) > 0 ? value.name : '', onSearch: onSearch, options: props.options, selectedKey: props.selectedKey, disabled: props.disabled });
};
